import { StreamDataHandlers } from 'streamsState/StreamDataService';
import { Store } from '@reduxjs/toolkit';
import {
    createReceiveMessageAction,
    createHandleStreamErrorAction,
} from './actions';
import { StreamError } from '../streamStatuses/StreamErrorState';
import { ChannelDestination } from 'communication/Channel';

export function buildByStreamKeyHandlers<TDataMessage>(
    store: Store,
    channel: ChannelDestination,
    allowMultiStream?: boolean
): StreamDataHandlers<TDataMessage> {
    return {
        onMessage: (streamKey: string, data: TDataMessage) =>
            store.dispatch(
                createReceiveMessageAction<TDataMessage>(
                    channel,
                    streamKey,
                    //TODO: fix types
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    data as any,
                    allowMultiStream
                )
            ),
        onError: (streamKey: string, error: StreamError) => {
            store.dispatch(
                createHandleStreamErrorAction(channel, streamKey, error)
            );
        },
    };
}
